import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const inputStyles = `
  width: 100%;
  padding: ${rem(8)};
  margin-top: ${rem(8)};
  font-size: 100%;
  line-height: ${rem(18)};
`;

export const InputStyled = styled.input`
  ${inputStyles}
  ${({ theme, customTheme }) => {
    if (customTheme === 'leads') {
      return css`
        background-color: rgba(255, 255, 255, 0.1);
        color: ${theme.colors.neutral.white};
        border:1px solid ${theme.colors.neutral.white};
        border-radius: ${rem(2)};
        height: ${rem(55)};
        font-weight:300;
        letter-spacing:${rem(1)};
        ::placeholder {
          color: ${theme.colors.neutral.gray95};
        }
        :-webkit-autofill,
        :-webkit-autofill:hover,
        :-webkit-autofill:focus,
        :-webkit-autofill:active,
        :-webkit-autofill::first-line {
          -webkit-box-shadow: 0 0 0 1000px #265e8a inset;
          -webkit-text-fill-color: ${theme.colors.neutral.white};
        }
    `;
    }
    return false;
  }
}
`;

// TODO: Consider adding a LEADS themed textarea, but it's not needed yet.
export const TextAreaStyled = styled.textarea`
  ${inputStyles}
`;
